import { API_BASE_URL } from "@/config";
import PassPort from "./elements/passport/PassPort.vue";
import SpouseDetail from "./elements/spouse/SpouseDetail.vue";
import { validate_form } from "@/utils/signio_validation.js";
import { allow_num, validate_id } from "@/utils/validations.js";

export default {
  name: "PersonalInformation",
  components: {
    PassPort,
    SpouseDetail,
  },
  emits: ["validity-change", "previous"],
  data() {
    return {
      form_data: {
        customerFirstName: "",
        customerMiddleName: "",
        customerSurname: "",
        customerIdType: "",
        customerIdNumber: "",
        customerDateOfBirth: "",
        passport_details: {
          customerPassportDateOfIssue: "",
          passportValidToDate: "",
          customerResidencePermitType: "Not Selected",
          customerResidencePermitNumber: "",
          customerResidencePermitCountryOfIssue: "",
          customerResidencePermitDateOfIssue: "",
          customerResidencePermitExpiryDate: "",
          customerWorkContractExpiryDate: "",
        },

        // Personal Information
        customerPreferredLanguage: "",
        customerGender: "Not Selected",
        customerTitle: "Not Selected",
        customerRaceEthnicGroup: "Not Selected",
        customerNationality: "SOUTH AFRICA",
        customerGraduate: "",
        customerLevelOfEducation: "Not Selected",
        customerMaritalStatus: "Not Selected",
        customerMaritalContract: "",
        dateMarried: "",
        customerPreferredContactMethod: "Not Selected",
        customerMobilePhoneNumber: "",
        mobileType: "",
        customerHomePhoneNumber: "",
        customerWorkPhoneNumberType: "",
        customerWorkPhoneNumber: "",
        customerEmail: "",
        countryOfBirth: "SOUTH AFRICA",
        isForeignOrTaxObligation: "Not Selected",
        isMultipleNationalities: "Not Selected",
        wasSouthAfricanCitizen: "Not Selected",
        countryCitizenship: "SOUTH AFRICA",
        residentialAddressCountry: "SOUTH AFRICA",

        // Residential Information
        customerResidentialAddressLine1: "",
        customerResidentialAddressSuburb: "",
        customerResidentialAddressCity: "",
        customerResidentialAddressPostalCode: "",
        sameAsRes: "Not Selected",
        customerPostalAddressLine1: "",
        customerPostalAddressSuburb: "",
        customerPostalAddressCity: "",
        customerPostalAddressPostalCode: "",
        ownerTenantLodger: "",
        outstandingBondBalance: null,
        jointHomeloanIndicator: "",
        jointBondPercentage: null,
        residentialOwner: "Not Selected",
        facilityValue: null,
        propertyCurrentValue: null,
        bondLenders: "Not Selected",
        customerPeriodAtCurrentAddressYears: "",
        customerPeriodAtCurrentAddressMonths: "",
        customerPeriodAtPreviousAddressYears: "",
        customerPeriodAtPreviousAddressMonths: "",
        spouse_details: {
          spouseFirstNames: "",
          spouseMiddleName: "",
          spouseSurname: "",
          spouseIdType: "Not Selected",
          spouseIdNo: "",
          spouseDateOfBirth: "",
          spousePhoneNumber: "",
        },

        // Relative Information fields
        relativeFirstNames: "",
        relativeSurname: "",
        relativeRelation: "Not Selected",
        relativePreferredContactMethod: "Not Selected",
        relativeCellphone: "",
        relativePhoneNumber: "",
        relativeWorkNumber: "",
        relativeAddressLine1: "",
        relativeAddressLine2: "",
        relativeAddressSuburb: "",
        relativeAddressCity: "",
        relativeAddressPostalCode: "",
      },
      countries: [
        "SOUTH AFRICA",
        "AFGANISTAN",
        "ALBANIA",
        "ALGERIA",
        "AMERICAN SAMOA",
        "ANDORRA",
        "ANGOLA",
        "ANTIGUA (WEST INDIES)",
        "ARGENTINA",
        "AUSTRALIA",
        "AUSTRIA",
        "AZORES",
        "BAHAMAS",
        "BAHRAIN",
        "BANGLADESH",
        "BARBADOS",
        "BELEARIC ISLAND (SPAIN)",
        "BELGIUM",
        "BELIZE",
        "BENIN",
        "BERMUDA",
        "BHUTAN",
        "BOLIVIA",
        "BOTSWANA",
        "BRAZIL",
        "BRUNEI",
        "BULGARIA",
        "BURUNDI",
        "CAMEROON (UNITED REPUBLIC OF)",
        "CANADA",
        "CAPE VERDE",
        "CAYMAN ISLAND (WEST INDIES)",
        "CENTRAL AFRICAN REPUBLIC",
        "CHAD",
        "CHILE",
        "CHINA",
        "CHRISTMAS ISLAND",
        "COCOS (KEELING) ISLAND",
        "COLUMBIA",
        "COMOROS",
        "CONGO (PEOPLE DEMOCRATIC REPUBLIC OF)",
        "COOK ISLAND",
        "COSTA RICA",
        "CUBA",
        "CYPRUS",
        "CZECHOSLOVAKIA",
        "DENMARK",
        "DJIBOUTI",
        "DOMINICA (WEST INDIES)",
        "DOMINICAN REPUBLIC",
        "EAST TIMOR",
        "ECUADOR",
        "EGYPT",
        "EL SALVADOR",
        "EQUATORIAL GUINEA",
        "ETHIOPIA",
        "FALKLAND ISLAND",
        "FEAROE ISLAND",
        "FIJI",
        "FINLAND",
        "FRANCE",
        "FRENCH GUIANA",
        "FRENCH POLYNESIA",
        "GABON",
        "GAMBIA",
        "GERMANY (DEMOCRATIC)",
        "GHANA",
        "GIBRALTAR",
        "GRANADA (WEST INDIES)",
        "GREECE",
        "GREENLAND",
        "GUADELOUPE (MARIE-GALANTE AND ST BARTHELEM)",
        "GUAM",
        "GUATEMALA",
        "GUINEA",
        "GUINEA-BISSAU",
        "GUYANA",
        "HAITI",
        "HONDURAS",
        "HONG KONG",
        "HUNGARY",
        "ICELAND",
        "INDIA",
        "INDONESIA",
        "IRAN",
        "IRAQ",
        "IRELAND",
        "ISREAL",
        "ITALY",
        "JAMAICA",
        "JAPAN",
        "JORDAN",
        "KENYA",
        "KIRIBATI",
        "KOREA (NORTH DEMOCRATIC PEOPLE REPUBLIC)",
        "KOREA (SOUTH DEMOCRATIC PEOPLE REPUBLIC)",
        "KUWAIT",
        "LAO (PEOPLE DEMOCRATIC REPUBLIC)",
        "LEBANON",
        "LESOTHO",
        "LIBERIA",
        "LIBYA",
        "LIECHTENSTEIN",
        "LUXEMBORG",
        "MACAU",
        "MADAGASCAR",
        "MALAWI (REPUBLIC OF)",
        "MALAYSIA",
        "MALDIVES",
        "MALI (REPUBLIC OF)",
        "MALTA-GOZO",
        "MARTINIQUE (FRENCH WEST INDIES)",
        "MAURITANIA",
        "MAURITIUS",
        "MEXICO",
        "MONACO",
        "MONGOLIA",
        "MONTSERRAT (WEST INDIES)",
        "MOROCCO",
        "MOZAMBIQUE",
        "NAMIBIA",
        "NAURU ISLAND",
        "NEPAL",
        "NETHERLANDS",
        "NETHERLANDS ANTILLES",
        "NEW CALEDONIA",
        "NEW ZEALAND",
        "NICARAGUA",
        "NIGER",
        "NIGERIA",
        "NIUE ISLAND",
        "NORFOLK ISLAND",
        "NORWAY",
        "OMAN",
        "PAKISTAN",
        "PALAU ISLANDS",
        "PANAMA",
        "PAPUA NEW GUINEA",
        "PARAGUAY",
        "PERU",
        "PHILLIPINES",
        "POLAND",
        "PORTUGAL",
        "PUERTO RICO",
        "QATAR",
        "REUNION",
        "ROMANIA",
        "RWANDA",
        "SAMOA",
        "SAN MARINO",
        "SAO TOME AND PRINCIPE",
        "SAUDI ARABIA",
        "SENEGAL",
        "SEYCHELLES",
        "SIERRA LEONNE",
        "SINGAPORE",
        "SOLOMON ISLANDS",
        "SOMALIA",
        "SPAIN",
        "SRI LANKA (CEYLON)",
        "ST HELENA",
        "ST KITTS-NEVAS ANGUILLA",
        "ST LUCIA",
        "SURINAM REPUBLIC",
        "SWAZI HOMELAND",
        "SWEDEN",
        "SWITZERLAND",
        "SYRIAN ARAB REPUBLIC",
        "TAIWAN",
        "TANZANIA (UNITED REPUBLIC OF)",
        "THAILAND",
        "TOGO (REPUBLIC OF)",
        "TOKELAU ISLANDS",
        "TONGA",
        "TRINIDAD AND TOBAGO",
        "TUNISIA",
        "TURKEY",
        "TURKS AND CAICOS ISLANDS",
        "TUVALU ISLANDS",
        "UGANDA",
        "UKRANIAN USSR",
        "UNITED ARAB EMIRATES",
        "UNITED KINGDOM",
        "UNITED STATES VIRGIN ISLANDS",
        "URUGUAY",
        "USA",
        "VANUATU ISLAND",
        "VENEZUELA",
        "VIETNAM",
        "WALLIS FUTUNA ISLANDS",
        "WESTERN SAHARA",
        "YEMEN",
        "YUGOSLAVIA",
        "ZAMBIA",
        "ZIMBABWE",
      ],
      bond_lenders_list: [
        "ABN AMRO BANK",
        "ABSA BANK",
        "AFRICAN BANK",
        "BANK WINDHOEK",
        "BIDVEST BANK",
        "BOE BANK (NEDBANK)",
        "CAPITEC BANK",
        "CITIBANK",
        "FBC FIDELITY BANK LTD",
        "FIRST NATIONAL BANK",
        "GRINDROD BANK",
        "HABIB OVERSEAS BANK",
        "HBZ BANK",
        "INVESTEC BANK LIMITED",
        "MERCANTILE BANK",
        "MFC",
        "MTN BANKING (Standard Bank)",
        "NBS (Nedbank)",
        "NEDBANK",
        "NEDBANK (Lesotho)",
        "NEDBANK (Namibia)",
        "NEDBANK (Swaziland)",
        "OTHER",
        "PEP BANK (NEDBANK)",
        "PERMANENT BANK",
        "RESERVE BANK",
        "SA BANK OF ATHENS",
        "SA POST OFFICE",
        "STANDARD BANK",
        "STANDARD BANK (SWAZILAND)",
        "STANDARD CHARTERED BANK (20TWENTY)",
        "STANDARD LESOTHO BANK LIMITED",
        "UBAN BANK",
        "Wesbank",
      ],
      // track collapsed state of sections
      collapsed_sections: {
        applicant_details: true,
        personal_information: false,
        residential_information: false,
        relative_information: false,
      }, 
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    allow_num,
    // navigate to previous section
    previous() {
      this.$emit("previous");
    },
    validate_number_only_field(value){
      if (value === null || value === undefined || value === "" || isNaN(value)) {
        return false; // Deny empty values
      }
      return true; // Valid number
    },
    validation_message_creation(message) {
      Swal.fire({
        title: "Field Validation Error",
        text: message,
        icon: "info",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    },
    applicant_detail_validation() {
      // Reset border styles
      $('#customer-first-name').removeClass('border-danger');
      $('#customer-middle-name').removeClass('border-danger');
      $('#customer-surname').removeClass('border-danger');
      $('#customer-id-type').removeClass('border-danger');
      $('#customer-id-number').removeClass('border-danger');
      $('#customer-date-of-birth').removeClass('border-danger');

      if (!this.form_data.customerFirstName) {
        this.validation_message_creation("Please enter your first name");
        $('#customer-first-name').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerFirstName.length < 3 || this.form_data.customerFirstName.length > 28) {
        this.validation_message_creation("First name must be between 3 and 28 characters.");
        $('#customer-first-name').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerMiddleName && this.form_data.customerMiddleName.length < 3 || this.form_data.customerMiddleName.length > 28) {
        this.validation_message_creation("Middle name must be between 3 and 28 characters.");
        $('#customer-middle-name').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerSurname) {
        this.validation_message_creation("Please enter your surname");
        $('#customer-surname').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerSurname.length < 3 || this.form_data.customerSurname.length > 55) {
        this.validation_message_creation("First name must be between 3 and 55 characters.");
        $('#customer-surname').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerIdType) {
        this.validation_message_creation("Please select your ID type");
        $('#customer-id-type').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerIdNumber) {
        this.validation_message_creation("Please enter your ID number");
        $('#customer-id-number').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerIdType == 'South African Valid ID' && !validate_id(this.form_data.customerIdNumber)) {
        this.validation_message_creation("Please enter a valid ID number");
        $('#customer-id-number').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerDateOfBirth) {
        this.validation_message_creation("Please enter your date of birth");
        $('#customer-date-of-birth').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerDateOfBirth) {
        var value = this.form_data.customerDateOfBirth;

        // Validate that the value is exactly 8 digits and in YYYYMMDD format
        if (value.length !== 8 || !/^\d+$/.test(value)) {
          this.validation_message_creation("Customer Data of Birth must be in YYYYMMDD format (8 digits).");
        $('#customer-date-of-birth').addClass('border-danger');
          return false;
        }

        // Extract year, month, day
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));
        const day = parseInt(value.substring(6, 8));

        // Validate year range (reasonable range)
        if (year < 1900 || year > new Date().getFullYear() + 100) {
          this.validation_message_creation(
            "Customer Data of Birth year must be between 1900 and " +
            (new Date().getFullYear() + 100) +
            "."
          );
        $('#customer-date-of-birth').addClass('border-danger');
          return false;
        }

        // Validate month
        if (month < 1 || month > 12) {
          this.validation_message_creation("Customer Data of Birth month must be between 01 and 12.");
        $('#customer-date-of-birth').addClass('border-danger');
          return false;
        }

        // Validate day
        if (day < 1 || day > 31) {
          this.validation_message_creation("Customer Data of Birth day must be between 01 and 31.");
        $('#customer-date-of-birth').addClass('border-danger');
          return false;
        }

        // Create a date object to check if the date is valid
        const date = new Date(year, month - 1, day);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day
        ) {
          this.validation_message_creation("Customer Data of Birth id invalid. Please check the day, month, and year.");
        $('#customer-date-of-birth').addClass('border-danger');
          return false;
        }
      }
      return true;
    },
    personal_information_validation() {
      // Reset border styles
      $('#customer-gender .form-check-input').removeClass('border-danger');
      $('#customer-title').removeClass('border-danger');
      $('#customer-race-ethnic-group').removeClass('border-danger');
      $('#customer-nationality').removeClass('border-danger');
      $('#customer-marital-status').removeClass('border-danger');
      $('#customer-marital-contract').removeClass('border-danger');
      $('#date-married').removeClass('border-danger');
      $('#customer-preferred-contact-method').removeClass('border-danger');
      $('#customer-mobile-phone-number').removeClass('border-danger');
      $('#customer-home-phone-number').removeClass('border-danger');
      $('#customer-work-phone-number').removeClass('border-danger');
      $('#customer-email').removeClass('border-danger');
      $('#country-of-birth').removeClass('border-danger');
      
      if (!this.form_data.customerGender || this.form_data.customerGender === "Not Selected") {
        this.validation_message_creation("Please select your gender");
        $('#customer-gender .form-check-input').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerTitle) {
        this.validation_message_creation("Please select your title");
        $('#customer-title').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerRaceEthnicGroup) {
        this.validation_message_creation("Please select your race");
        $('#customer-race-ethnic-group').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerNationality) {
        this.validation_message_creation("Please select country of nationality");
        $('#customer-nationality').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerMaritalStatus) {
        this.validation_message_creation("Please select your marital status");
        $('#customer-marital-status').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerMaritalStatus === "Married" && !this.form_data.customerMaritalContract) {
        this.validation_message_creation("Please select your marital contract type");
        $('#customer-marital-contract').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerMaritalStatus === "Married" && !this.form_data.dateMarried) {
        this.validation_message_creation("Please enter the date you got married");
        $('#date-married').addClass('border-danger');
        return false;
      }
      if (this.form_data.dateMarried) {
        var value = this.form_data.dateMarried;
        // Validate that the value is exactly 8 digits and in YYYYMMDD format
        if (value.length !== 8 || !/^\d+$/.test(value)) {
          this.validation_message_creation("Date Married must be in YYYYMMDD format (8 digits).");
          $('#date-married').addClass('border-danger');
          return false;
        }

        // Extract year, month, day
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));
        const day = parseInt(value.substring(6, 8));
        // Validate year range (reasonable range)
        if (year < 1900 || year > new Date().getFullYear() + 100) {
          this.validation_message_creation(
            "Date Married year must be between 1900 and " +
            (new Date().getFullYear() + 100) + "."
          );
          $('#date-married').addClass('border-danger');
          return false;
        }
        // Validate month
        if (month < 1 || month > 12) {
          this.validation_message_creation("Date Married month must be between 01 and 12.");
          $('#date-married').addClass('border-danger');
          return false;
        }
        // Validate day
        if (day < 1 || day > 31) {
          this.validation_message_creation("Date Married day must be between 01 and 31.");
          $('#date-married').addClass('border-danger');
          return false;
        }
        // Create a date object to check if the date is valid
        const date = new Date(year, month - 1, day);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day
        ) {
          this.validation_message_creation("Date Married is invalid. Please check the day, month, and year.");
          $('#date-married').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.customerPreferredContactMethod) {
        this.validation_message_creation("Please select your preferred contact method");
        $('#customer-preferred-contact-method').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerMobilePhoneNumber) {
        this.validation_message_creation("Please enter your mobile phone number");
        $('#customer-mobile-phone-number').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerMobilePhoneNumber) {
        const phone_regex = /^\d{10}$/; // Assuming South African phone numbers
        if (!phone_regex.test(this.form_data.customerMobilePhoneNumber)) {
          this.validation_message_creation("Please enter a valid mobile phone number (10 digits)");
          $('#customer-mobile-phone-number').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.customerHomePhoneNumber) {
        this.validation_message_creation("Please enter your home phone number");
        $('#customer-home-phone-number').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerWorkPhoneNumber) {
        this.validation_message_creation("Please enter your work phone number");
        $('#customer-work-phone-number').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerWorkPhoneNumber) {
        const phone_regex = /^\d{10}$/; // Assuming South African phone numbers
        if (!phone_regex.test(this.form_data.customerWorkPhoneNumber)) {
          this.validation_message_creation("Please enter a valid work phone number (10 digits)");
          $('#customer-work-phone-number').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.customerEmail) {
        this.validation_message_creation("Please enter your email address");
        $('#customer-email').addClass('border-danger');
        return false;
      }
      if (this.form_data.customerEmail) {
        const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email_regex.test(this.form_data.customerEmail)) {
          this.validation_message_creation("Please enter a valid email address");
          $('#customer-email').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.countryOfBirth) {
        this.validation_message_creation("Please select your country of birth");
        $('#country-of-birth').addClass('border-danger');
        return false;
      }
      return true;
    },
    residential_information_validation(){
      // Reset border styles
      $('#customer-residential-address-line-1').removeClass('border-danger');
      $('#customer-residential-address-suburb').removeClass('border-danger');
      $('#customer-residential-address-city').removeClass('border-danger');
      $('#customer-residential-address-postal-code').removeClass('border-danger');
      $('#customer-postal-address-line-1').removeClass('border-danger');
      $('#customer-postal-address-suburb').removeClass('border-danger');
      $('#customer-postal-address-city').removeClass('border-danger');
      $('#customer-postal-address-postal-code').removeClass('border-danger');
      $('#customer-period-at-current-address-years').removeClass('border-danger');
      $('#customer-period-at-current-address-months').removeClass('border-danger');
      $('#customer-period-at-previous-address-years').removeClass('border-danger');
      $('#customer-period-at-previous-address-months').removeClass('border-danger');

      if (!this.form_data.customerResidentialAddressLine1) {
        this.validation_message_creation("Please enter your residential address line 1");
        $('#customer-residential-address-line-1').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerResidentialAddressSuburb) {
        this.validation_message_creation("Please enter your residential address suburb");
        $('#customer-residential-address-suburb').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerResidentialAddressCity) {
        this.validation_message_creation("Please enter your residential address city");
        $('#customer-residential-address-city').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerResidentialAddressPostalCode) {
        this.validation_message_creation("Please enter your residential address postal code");
        $('#customer-residential-address-postal-code').addClass('border-danger');
        return false;
      }

      // Postal Address Verification
      if (this.form_data.sameAsRes && this.form_data.sameAsRes === "Use Address Below") {
        if (!this.form_data.customerPostalAddressLine1) {
          this.validation_message_creation("Please enter your postal address line 1");
          $('#customer-postal-address-line-1').addClass('border-danger');
          return false;
        }
        if (!this.form_data.customerPostalAddressSuburb) {
          this.validation_message_creation("Please enter your postal address suburb");
          $('#customer-postal-address-suburb').addClass('border-danger');
          return false;
        }
        if (!this.form_data.customerPostalAddressCity) {
          this.validation_message_creation("Please enter your postal address city");
          $('#customer-postal-address-city').addClass('border-danger');
          return false;
        }
        if (!this.form_data.customerPostalAddressPostalCode) {
          this.validation_message_creation("Please enter your postal address postal code");
          $('#customer-postal-address-postal-code').addClass('border-danger');
          return false;
        }
      }

      // Current Address Verification
      if (!this.validate_number_only_field(this.form_data.customerPeriodAtCurrentAddressYears)){
          this.validation_message_creation("Please enter a valid period at current address (years).");
          $('#customer-period-at-current-address-years').addClass('border-danger');
          return false;
      }
      if (!this.validate_number_only_field(this.form_data.customerPeriodAtCurrentAddressMonths)){
          this.validation_message_creation("Please enter a valid period at current address (months).");
          $('#customer-period-at-current-address-months').addClass('border-danger');
          return false;
      }
      if (
        this.form_data.customerPeriodAtCurrentAddressYears < 0 || this.form_data.customerPeriodAtCurrentAddressYears > 99
      ) {
        this.validation_message_creation("Years at current address must be between 0 and 99.");
        $('#customer-period-at-current-address-years').addClass('border-danger');
        return false;
      }
      if (
        this.form_data.customerPeriodAtCurrentAddressMonths < 0 || this.form_data.customerPeriodAtCurrentAddressMonths > 11
      ) {
        this.validation_message_creation("Months at current address must be between 0 and 11.");
        $('#customer-period-at-current-address-months').addClass('border-danger');
        return false;
      }

      if (
        !this.validate_number_only_field(this.form_data.customerPeriodAtPreviousAddressYears)
      ) {
        this.validation_message_creation("Please enter a valid period at previous address (years).");
        $('#customer-period-at-previous-address-years').addClass('border-danger');
        return false;
      }
      if (
        !this.validate_number_only_field(this.form_data.customerPeriodAtPreviousAddressMonths)
      ) {
        this.validation_message_creation("Please enter a valid period at previous address (months).");
        $('#customer-period-at-previous-address-months').addClass('border-danger');
        return false;
      }
      if (
        this.form_data.customerPeriodAtPreviousAddressYears < 0 ||
        this.form_data.customerPeriodAtPreviousAddressYears > 99
      ) {
        this.validation_message_creation("Years at previous address must be between 0 and 99.");
        $('#customer-period-at-previous-address-years').addClass('border-danger');
        return false;
      }
      if (
        this.form_data.customerPeriodAtPreviousAddressMonths < 0 ||
        this.form_data.customerPeriodAtPreviousAddressMonths > 11
      ) {
        this.validation_message_creation("Months at previous address must be between 0 and 11.");
        $('#customer-period-at-previous-address-months').addClass('border-danger');
        return false;
      }
      return true;
    },
    relative_information_validation() {
      // Reset border styles
      $('#relative-first-names').removeClass('border-danger');
      $('#relative-surname').removeClass('border-danger');
      $('#relative-relation').removeClass('border-danger');
      $('#relative-preferred-contact-method').removeClass('border-danger');
      $('#relative-cellphone').removeClass('border-danger');
      $('#relative-phone-number').removeClass('border-danger');
      $('#relative-work-number').removeClass('border-danger');
      $('#relative-address-line-1').removeClass('border-danger');
      $('#relative-address-line-2').removeClass('border-danger');
      $('#relative-address-suburb').removeClass('border-danger');
      $('#relative-address-city').removeClass('border-danger');
      $('#relative-address-postal-code').removeClass('border-danger');

      if (!this.form_data.relativeFirstNames) {
        this.validation_message_creation("Please enter the relative's first names");
        $('#relative-first-names').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeSurname) {
        this.validation_message_creation("Please enter the relative's surname");
        $('#relative-surname').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeRelation || this.form_data.relativeRelation === "Not Selected") {
        this.validation_message_creation("Please select the relative's relation to you");
        $('#relative-relation').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativePreferredContactMethod || this.form_data.relativePreferredContactMethod === "Not Selected") {
        this.validation_message_creation("Please select the relative's preferred contact method");
        $('#relative-preferred-contact-method').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeCellphone) {
        this.validation_message_creation("Please enter the relative's cellphone number");
        $('#relative-cellphone').addClass('border-danger');
        return false;
      }
      if (this.form_data.relativeCellphone) {
        const phone_regex = /^\d{10}$/; // Assuming South African phone numbers
        if (!phone_regex.test(this.form_data.relativeCellphone)) {
          this.validation_message_creation("Please enter a valid cellphone number (10 digits)");
          $('#relative-cellphone').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.relativePhoneNumber) {
        this.validation_message_creation("Please enter the relative's phone number");
        $('#relative-phone-number').addClass('border-danger');
        return false;
      }
      if (this.form_data.relativePhoneNumber) {
        const phone_regex = /^\d{10}$/; // Assuming South African phone numbers
        if (!phone_regex.test(this.form_data.relativePhoneNumber)) {
          this.validation_message_creation("Please enter a valid phone number (10 digits)");
          $('#relative-phone-number').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.relativeWorkNumber) {
        this.validation_message_creation("Please enter the relative's work number");
        $('#relative-work-number').addClass('border-danger');
        return false;
      }
      if (this.form_data.relativeWorkNumber) {
        const phone_regex = /^\d{10}$/; // Assuming South African phone numbers
        if (!phone_regex.test(this.form_data.relativeWorkNumber)) {
          this.validation_message_creation("Please enter a valid work number (10 digits)");
          $('#relative-work-number').addClass('border-danger');
          return false;
        }
      }
      if (!this.form_data.relativeAddressLine1) {
        this.validation_message_creation("Please enter the relative's address line 1");
        $('#relative-address-line-1').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeAddressLine2) {
        this.validation_message_creation("Please enter the relative's address line 2");
        $('#relative-address-line-2').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeAddressSuburb) {
        this.validation_message_creation("Please enter the relative's address suburb");
        $('#relative-address-suburb').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeAddressCity) {
        this.validation_message_creation("Please enter the relative's address city");
        $('#relative-address-city').addClass('border-danger');
        return false;
      }
      if (!this.form_data.relativeAddressPostalCode) {
        this.validation_message_creation("Please enter the relative's address postal code");
        $('#relative-address-postal-code').addClass('border-danger');
        return false;
      }
      return true;
    },
    validate_section(current_section) {
      // Validate the current section before proceeding
      let validated = false;
      switch (current_section) {
        case "applicant_details":
          validated = this.applicant_detail_validation();
          break;
        case "personal_information":
          validated = this.personal_information_validation();
          break;
        case "residential_information":
          validated = this.residential_information_validation();
          break;
        case "relative_information":
          validated = this.relative_information_validation();
          break;
        default:
          console.error("Unknown section:", current_section);
          break;
      }
      return validated;
    },
    go_to_previous_section() {
      const sections = Object.keys(this.collapsed_sections);
      const current_index = sections.findIndex(section => this.collapsed_sections[section]);
      if (current_index > 0) {
        const prev_section = sections[current_index - 1];
        this.toggle(prev_section);
      }
    },
    go_to_next_section() {
      
      // Find the current section based on the collapsed state
      const current_section = Object.keys(this.collapsed_sections).find(section => this.collapsed_sections[section]);
      if (!current_section) return; // No section is currently collapsed

      // Validate the current section before proceeding
      var validated = this.validate_section(current_section);

      if (!validated) {
        return; // If validation fails, do not proceed
      }

      // If all required inputs are filled, proceed to the next section
      // Find the next section based on the current collapsed state
      const sections = Object.keys(this.collapsed_sections);
      const current_index = sections.findIndex(section => this.collapsed_sections[section]);
      if (current_index < sections.length - 1 && current_index !== -1) {
        const next_section = sections[current_index + 1];
        this.toggle(next_section);
      }
    },
    // toggle collapse state
    toggle(section) {
      // Toggle the selected section and collapse all others
      Object.keys(this.collapsed_sections).forEach(key => {
        this.collapsed_sections[key] = (key === section) ? !this.collapsed_sections[key] : false;
      });
    },
    // Add methods for form validation, submission, etc.
    submit_section() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/sygnio_answer/`;

      const { passport_details, spouse_details, ...rest } = this.form_data;
      const merged_answers = {
        ...rest,
        ...passport_details,
        ...spouse_details,
      };
      const answers = Object.keys(merged_answers).map((key) => ({
        answer: merged_answers[key],
        api_form_field: key,
      }));

      if(!this.applicant_detail_validation()){
        this.toggle("applicant_details");
        return;
      }
      if(!this.personal_information_validation()){
        this.toggle("personal_information");
        return;
      }
      if(!this.residential_information_validation()){
        this.toggle("residential_information");
        return;
      }
      if(!this.relative_information_validation()){
        return;
      }

      var errors = validate_form(merged_answers);
      if (errors.length > 0) {
        {
          const msg = errors
            .map(err => {
              return `${err.error}`
            })
            .join("\n")

          Swal.fire({
            title: "Validation Error",
            text: msg,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          })
        }
        return;
      }

      $.ajax({
        type: "POST",
        url: service_api,
        headers: {
          Authorization: `Token ${token}`,
        },
        data: JSON.stringify({
          answers: answers,
          workflow_id: this.workflow_id,
        }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              title: "Success",
              text: "Your information has been submitted successfully!",
              icon: "success",
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then(() => {
              this.$emit("validity-change", true)
            });
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to submit the information, try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
    fetch_sygnio_answers() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/get_sygnio_question_answers/`;

      $.ajax({
        type: "POST",
        url: service_api,
        headers: {
          Authorization: `Token ${token}`,
        },
        data: JSON.stringify({ workflow_id: this.workflow_id }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success" && response.data) {
            const data = response.data;
            if (Array.isArray(data)) {
              data.forEach((item) => {
                const key = item.api_form_field;
                const value = item.answer;
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                } else if (this.form_data.passport_details[key] !== undefined) {
                  this.form_data.passport_details[key] = value;
                } else if (this.form_data.spouse_details[key] !== undefined) {
                  this.form_data.spouse_details[key] = value;
                }
              });
            } else if (typeof data === "object") {
              Object.keys(data).forEach((key) => {
                const value = data[key];
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                } else if (this.form_data.passport_details[key] !== undefined) {
                  this.form_data.passport_details[key] = value;
                } else if (this.form_data.spouse_details[key] !== undefined) {
                  this.form_data.spouse_details[key] = value;
                }
              });
            }
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to fetch the answers, please try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
  },
  
  watch: {
    "form_data.customerIdNumber": function (new_val) {
      // When SA ID is 13 digits, auto-populate DOB and gender
      if (/^\d{13}$/.test(new_val)) {
        const yy = new_val.slice(0, 2);
        const mm = new_val.slice(2, 4);
        const dd = new_val.slice(4, 6);

        // Determine century: if year > current year's last two digits, assume 1900s else 2000s
        const current_two = new Date().getFullYear() % 100;
        const century_prefix = parseInt(yy, 10) > current_two ? "19" : "20";
        this.form_data.customerDateOfBirth = `${century_prefix}${yy}${mm}${dd}`;

        // Gender code from digits 7-10
        const gender_code = parseInt(new_val.slice(6, 10), 10);
        this.form_data.customerGender = gender_code >= 5000 ? "Male" : "Female";
      }
    },
  },
  mounted() {
    this.fetch_sygnio_answers();
  },
};
